[
  {
    "meta": {
      "protocolVersion": "27.2.0",
      "implementation": {
        "name": "cucumber-node",
        "version": "0.4.0"
      },
      "cpu": {
        "name": "arm64"
      },
      "os": {
        "name": "darwin",
        "version": "24.4.0"
      },
      "runtime": {
        "name": "Node.js",
        "version": "23.7.0"
      }
    }
  },
  {
    "source": {
      "uri": "features/deletion.feature",
      "data": "Feature: Deletion\n\n  Reports aren't kept around forever.\n\n  They are automatically deleted after a short period, and can also be proactively deleted by the user.\n\n  Scenario: Deletion is scheduled for 24 hours after publication\n    When Bruno publishes a report\n    And Bruno views the report they just published\n    Then Bruno should see that the report is scheduled for deletion\n\n  Scenario: Proactively deleting a report\n\n  One can always wait for the automatic deletion, but if a report has\n  accidentally included sensitive information, it can be deleted proactively.\n\n    When Clara publishes a report\n    And Clara views the report they just published\n    And Clara deletes the report\n    Then Clara should see that the report was deleted\n\n  Scenario: Viewing a deleted report\n\n  The link for a report might be saved and opened sometime after deletion.\n\n    Given a report previously published by Esme has been deleted\n    When Esme attempts to view their report\n    Then Esme should see that no report was found",
      "mediaType": "text/x.cucumber.gherkin+plain"
    }
  },
  {
    "gherkinDocument": {
      "uri": "features/deletion.feature",
      "feature": {
        "tags": [],
        "location": {
          "line": 1,
          "column": 1
        },
        "language": "en",
        "keyword": "Feature",
        "name": "Deletion",
        "description": "  Reports aren't kept around forever.\n\n  They are automatically deleted after a short period, and can also be proactively deleted by the user.",
        "children": [
          {
            "scenario": {
              "id": "52b15127-0dcd-49d1-8194-afbb8fa2dabb",
              "tags": [],
              "location": {
                "line": 6,
                "column": 3
              },
              "keyword": "Scenario",
              "name": "Deletion is scheduled for 24 hours after publication",
              "description": "",
              "steps": [
                {
                  "id": "33c15567-b8fd-4eac-90ee-21f8b686a7bf",
                  "location": {
                    "line": 7,
                    "column": 5
                  },
                  "keyword": "When ",
                  "keywordType": "Action",
                  "text": "Bruno publishes a report"
                },
                {
                  "id": "a13697fa-22e1-4703-bf48-581c8b3857f7",
                  "location": {
                    "line": 8,
                    "column": 5
                  },
                  "keyword": "And ",
                  "keywordType": "Conjunction",
                  "text": "Bruno views the report they just published"
                },
                {
                  "id": "18a0f6ec-8b85-42b1-abc7-da6be3a3ec5f",
                  "location": {
                    "line": 9,
                    "column": 5
                  },
                  "keyword": "Then ",
                  "keywordType": "Outcome",
                  "text": "Bruno should see that the report is scheduled for deletion"
                }
              ],
              "examples": []
            }
          },
          {
            "scenario": {
              "id": "c0a41ac1-ba45-44cb-9b8a-79744ac0805d",
              "tags": [],
              "location": {
                "line": 11,
                "column": 3
              },
              "keyword": "Scenario",
              "name": "Proactively deleting a report",
              "description": "  One can always wait for the automatic deletion, but if a report has\n  accidentally included sensitive information, it can be deleted proactively.",
              "steps": [
                {
                  "id": "9f545376-1d8c-4ad3-a2ab-0c8fbf23f125",
                  "location": {
                    "line": 16,
                    "column": 5
                  },
                  "keyword": "When ",
                  "keywordType": "Action",
                  "text": "Clara publishes a report"
                },
                {
                  "id": "39a97999-d0ac-41e9-aebe-adab626e1dac",
                  "location": {
                    "line": 17,
                    "column": 5
                  },
                  "keyword": "And ",
                  "keywordType": "Conjunction",
                  "text": "Clara views the report they just published"
                },
                {
                  "id": "81a8e0d3-21de-4088-af1f-46326d1cab07",
                  "location": {
                    "line": 18,
                    "column": 5
                  },
                  "keyword": "And ",
                  "keywordType": "Conjunction",
                  "text": "Clara deletes the report"
                },
                {
                  "id": "d00732a7-3cf0-407a-8e20-33e5f60e248e",
                  "location": {
                    "line": 19,
                    "column": 5
                  },
                  "keyword": "Then ",
                  "keywordType": "Outcome",
                  "text": "Clara should see that the report was deleted"
                }
              ],
              "examples": []
            }
          },
          {
            "scenario": {
              "id": "3a0ceef5-a835-4805-be2c-b96c51e86d3d",
              "tags": [],
              "location": {
                "line": 21,
                "column": 3
              },
              "keyword": "Scenario",
              "name": "Viewing a deleted report",
              "description": "  The link for a report might be saved and opened sometime after deletion.",
              "steps": [
                {
                  "id": "b445481c-81a3-4301-acf9-74332c693e09",
                  "location": {
                    "line": 25,
                    "column": 5
                  },
                  "keyword": "Given ",
                  "keywordType": "Context",
                  "text": "a report previously published by Esme has been deleted"
                },
                {
                  "id": "91639ae3-c239-4b66-8194-539f6b7e3e40",
                  "location": {
                    "line": 26,
                    "column": 5
                  },
                  "keyword": "When ",
                  "keywordType": "Action",
                  "text": "Esme attempts to view their report"
                },
                {
                  "id": "68973b1f-3248-4af2-a18a-2664453e8996",
                  "location": {
                    "line": 27,
                    "column": 5
                  },
                  "keyword": "Then ",
                  "keywordType": "Outcome",
                  "text": "Esme should see that no report was found"
                }
              ],
              "examples": []
            }
          }
        ]
      },
      "comments": []
    }
  },
  {
    "pickle": {
      "id": "167acb8f-e467-4fa6-b9f3-0a9192f0ee3a",
      "uri": "features/deletion.feature",
      "astNodeIds": ["52b15127-0dcd-49d1-8194-afbb8fa2dabb"],
      "tags": [],
      "name": "Deletion is scheduled for 24 hours after publication",
      "language": "en",
      "steps": [
        {
          "id": "b3863557-92ca-431b-8f2b-d411e5d5c555",
          "text": "Bruno publishes a report",
          "type": "Action",
          "astNodeIds": ["33c15567-b8fd-4eac-90ee-21f8b686a7bf"]
        },
        {
          "id": "231fc513-2272-40f9-9d58-c2e54666660f",
          "text": "Bruno views the report they just published",
          "type": "Action",
          "astNodeIds": ["a13697fa-22e1-4703-bf48-581c8b3857f7"]
        },
        {
          "id": "41111b06-28dd-4c76-92df-49d7d634735e",
          "text": "Bruno should see that the report is scheduled for deletion",
          "type": "Outcome",
          "astNodeIds": ["18a0f6ec-8b85-42b1-abc7-da6be3a3ec5f"]
        }
      ]
    }
  },
  {
    "pickle": {
      "id": "aea12470-363c-4258-83c2-6fe76654fb47",
      "uri": "features/deletion.feature",
      "astNodeIds": ["c0a41ac1-ba45-44cb-9b8a-79744ac0805d"],
      "tags": [],
      "name": "Proactively deleting a report",
      "language": "en",
      "steps": [
        {
          "id": "1bb2b0e3-f043-4466-a0d9-ff0705354280",
          "text": "Clara publishes a report",
          "type": "Action",
          "astNodeIds": ["9f545376-1d8c-4ad3-a2ab-0c8fbf23f125"]
        },
        {
          "id": "60e8eef7-b90a-44e9-b909-fe1387030ea1",
          "text": "Clara views the report they just published",
          "type": "Action",
          "astNodeIds": ["39a97999-d0ac-41e9-aebe-adab626e1dac"]
        },
        {
          "id": "f8f38cf2-c675-4196-9a43-e2375d05f0c4",
          "text": "Clara deletes the report",
          "type": "Action",
          "astNodeIds": ["81a8e0d3-21de-4088-af1f-46326d1cab07"]
        },
        {
          "id": "18f03b3b-5fa9-4cb1-b068-4465136ada62",
          "text": "Clara should see that the report was deleted",
          "type": "Outcome",
          "astNodeIds": ["d00732a7-3cf0-407a-8e20-33e5f60e248e"]
        }
      ]
    }
  },
  {
    "pickle": {
      "id": "c1c81fc5-a115-4e53-b431-173ab1f27d12",
      "uri": "features/deletion.feature",
      "astNodeIds": ["3a0ceef5-a835-4805-be2c-b96c51e86d3d"],
      "tags": [],
      "name": "Viewing a deleted report",
      "language": "en",
      "steps": [
        {
          "id": "4627173e-f187-4020-b26c-b620643b7e69",
          "text": "a report previously published by Esme has been deleted",
          "type": "Context",
          "astNodeIds": ["b445481c-81a3-4301-acf9-74332c693e09"]
        },
        {
          "id": "9396b6c7-3bff-4679-ab54-11492479934d",
          "text": "Esme attempts to view their report",
          "type": "Action",
          "astNodeIds": ["91639ae3-c239-4b66-8194-539f6b7e3e40"]
        },
        {
          "id": "ae829390-91e2-4f1c-a0f2-74a195e0ca3f",
          "text": "Esme should see that no report was found",
          "type": "Outcome",
          "astNodeIds": ["68973b1f-3248-4af2-a18a-2664453e8996"]
        }
      ]
    }
  },
  {
    "parameterType": {
      "id": "44182741-9784-4a77-aa84-080520bbc88a",
      "name": "actor",
      "regularExpressions": ["[A-Z][a-z]+"],
      "preferForRegularExpressionMatch": false,
      "useForSnippets": true,
      "sourceReference": {
        "uri": "features/steps/setup.mts",
        "location": {
          "line": 1,
          "column": 201
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "b1279182-f585-467a-a805-39ef5c391af4",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} has a private token"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 621
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "faa5218b-a490-4e70-85ef-01dd8a45d8be",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "a report previously published by {actor} has been deleted"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 746
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "82b2a494-d7f9-4a2a-a525-fe07cbb4ed89",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} publishes a report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 963
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "584f5b2f-2acc-4e5c-894a-1bf0f5902f0a",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} shares their link with {actor}"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1193
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "9b0eb230-4b77-4ee3-8bea-8ee4569bf8ca",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} views the report they just published"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1378
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "6acde4db-4adc-45de-bb9d-d442cadba7e2",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} views the shared report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1558
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "c9258031-5b07-4570-9273-0db9e403ab3e",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} attempts to view their report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1721
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "7d178177-12b8-450b-84fa-90d0ce98a463",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} deletes the report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1894
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "e5c69df6-3fa4-453e-bfdb-79aa08cf1207",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} accesses the site directly"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2006
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "2355859b-4fde-4ac8-836c-e5c37ebee97a",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see a sample report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2147
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "4af31222-f9b7-4c20-b958-046de39ea802",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see the(ir) test results"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2271
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "aa48b142-fc4b-4058-ac20-d65bd1770df1",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that the report is scheduled for deletion"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2401
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "c493b774-07ff-4c20-8d03-94387d2626df",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see the message:"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2561
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "4e973926-85eb-4d53-852b-0dd7b8a72818",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "no report should be published"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2720
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "1ef6165e-3f71-4087-940d-e51aaec16a00",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that the report was deleted"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2848
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "28f258b9-f2f9-4cab-a1ed-3d09c465d784",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that no report was found"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2982
        }
      }
    }
  },
  {
    "source": {
      "uri": "features/publishing.feature",
      "data": "Feature: Publishing\n\n  Scenario: Report is immediately accessible after the run\n    When David publishes a report\n    And David views the report they just published\n    Then David should see their test results\n\n  Scenario: Reports are publicly accessible with the URL\n    When Garrett publishes a report\n    And Garrett shares their link with Hannah\n    When Hannah views the shared report\n    Then Hannah should see the test results\n",
      "mediaType": "text/x.cucumber.gherkin+plain"
    }
  },
  {
    "gherkinDocument": {
      "uri": "features/publishing.feature",
      "feature": {
        "tags": [],
        "location": {
          "line": 1,
          "column": 1
        },
        "language": "en",
        "keyword": "Feature",
        "name": "Publishing",
        "description": "",
        "children": [
          {
            "scenario": {
              "id": "4f75ee63-0be3-490c-a1e5-c1192b4dec75",
              "tags": [],
              "location": {
                "line": 3,
                "column": 3
              },
              "keyword": "Scenario",
              "name": "Report is immediately accessible after the run",
              "description": "",
              "steps": [
                {
                  "id": "df5f8e1c-dd39-472d-a80c-b43e4ce58b2f",
                  "location": {
                    "line": 4,
                    "column": 5
                  },
                  "keyword": "When ",
                  "keywordType": "Action",
                  "text": "David publishes a report"
                },
                {
                  "id": "7492d129-4d38-402e-8be9-71c3788c77e4",
                  "location": {
                    "line": 5,
                    "column": 5
                  },
                  "keyword": "And ",
                  "keywordType": "Conjunction",
                  "text": "David views the report they just published"
                },
                {
                  "id": "1d85cbf8-1bba-4cfa-bfa3-dcb49bd5531d",
                  "location": {
                    "line": 6,
                    "column": 5
                  },
                  "keyword": "Then ",
                  "keywordType": "Outcome",
                  "text": "David should see their test results"
                }
              ],
              "examples": []
            }
          },
          {
            "scenario": {
              "id": "3d165ded-36cb-4c33-875b-5da85afa3d19",
              "tags": [],
              "location": {
                "line": 8,
                "column": 3
              },
              "keyword": "Scenario",
              "name": "Reports are publicly accessible with the URL",
              "description": "",
              "steps": [
                {
                  "id": "b45e907e-313f-449f-abe4-47dec46dbf42",
                  "location": {
                    "line": 9,
                    "column": 5
                  },
                  "keyword": "When ",
                  "keywordType": "Action",
                  "text": "Garrett publishes a report"
                },
                {
                  "id": "d4ed0a52-a3c2-4e11-981f-a57ed916104b",
                  "location": {
                    "line": 10,
                    "column": 5
                  },
                  "keyword": "And ",
                  "keywordType": "Conjunction",
                  "text": "Garrett shares their link with Hannah"
                },
                {
                  "id": "d91b8621-8184-49d7-b20e-ad0b02274239",
                  "location": {
                    "line": 11,
                    "column": 5
                  },
                  "keyword": "When ",
                  "keywordType": "Action",
                  "text": "Hannah views the shared report"
                },
                {
                  "id": "4b456ddb-f8ff-4050-b7c4-943cdc04f7ae",
                  "location": {
                    "line": 12,
                    "column": 5
                  },
                  "keyword": "Then ",
                  "keywordType": "Outcome",
                  "text": "Hannah should see the test results"
                }
              ],
              "examples": []
            }
          }
        ]
      },
      "comments": []
    }
  },
  {
    "pickle": {
      "id": "cb587150-8686-4ef8-a299-d2963a20429c",
      "uri": "features/publishing.feature",
      "astNodeIds": ["4f75ee63-0be3-490c-a1e5-c1192b4dec75"],
      "tags": [],
      "name": "Report is immediately accessible after the run",
      "language": "en",
      "steps": [
        {
          "id": "3a7cfbbe-5ec0-4218-9179-a5216014a701",
          "text": "David publishes a report",
          "type": "Action",
          "astNodeIds": ["df5f8e1c-dd39-472d-a80c-b43e4ce58b2f"]
        },
        {
          "id": "fde4bbce-f08d-4faf-869a-4d3ffd92570f",
          "text": "David views the report they just published",
          "type": "Action",
          "astNodeIds": ["7492d129-4d38-402e-8be9-71c3788c77e4"]
        },
        {
          "id": "06622832-9d95-4f58-8347-eb2f6126a461",
          "text": "David should see their test results",
          "type": "Outcome",
          "astNodeIds": ["1d85cbf8-1bba-4cfa-bfa3-dcb49bd5531d"]
        }
      ]
    }
  },
  {
    "pickle": {
      "id": "24bee1a1-8d28-4771-a3eb-d20a4c2cf26c",
      "uri": "features/publishing.feature",
      "astNodeIds": ["3d165ded-36cb-4c33-875b-5da85afa3d19"],
      "tags": [],
      "name": "Reports are publicly accessible with the URL",
      "language": "en",
      "steps": [
        {
          "id": "dac60d43-b9aa-4ac4-9c79-ba75cc2a9019",
          "text": "Garrett publishes a report",
          "type": "Action",
          "astNodeIds": ["b45e907e-313f-449f-abe4-47dec46dbf42"]
        },
        {
          "id": "2063c9d5-706f-4818-a4a5-e654a23662ee",
          "text": "Garrett shares their link with Hannah",
          "type": "Action",
          "astNodeIds": ["d4ed0a52-a3c2-4e11-981f-a57ed916104b"]
        },
        {
          "id": "624d8291-6722-42e7-8327-d163476b9bc5",
          "text": "Hannah views the shared report",
          "type": "Action",
          "astNodeIds": ["d91b8621-8184-49d7-b20e-ad0b02274239"]
        },
        {
          "id": "0013d8df-acfd-457c-9aff-8241bda6fdf0",
          "text": "Hannah should see the test results",
          "type": "Outcome",
          "astNodeIds": ["4b456ddb-f8ff-4050-b7c4-943cdc04f7ae"]
        }
      ]
    }
  },
  {
    "parameterType": {
      "id": "f136c04c-42f7-4bc5-a5b0-5ce50c40665b",
      "name": "actor",
      "regularExpressions": ["[A-Z][a-z]+"],
      "preferForRegularExpressionMatch": false,
      "useForSnippets": true,
      "sourceReference": {
        "uri": "features/steps/setup.mts",
        "location": {
          "line": 1,
          "column": 201
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "6f0bc645-fea5-40cd-9810-368ec01f7b7a",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} has a private token"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 621
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "ec28303a-7b4f-4337-9b79-53590b2cf150",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "a report previously published by {actor} has been deleted"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 746
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "54ce4487-50ba-4382-9903-9f2ff2f19cb7",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} publishes a report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 963
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "839b104f-abce-44d4-bbc3-30af6a1d953f",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} shares their link with {actor}"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1193
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "eb99bfd3-f2a0-4351-8503-57772bd4eb46",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} views the report they just published"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1378
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "8982004d-ce05-46a5-b7f4-4481ec99f750",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} views the shared report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1558
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "855b6238-33d0-4ea9-9300-d8cb6eb114e8",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} attempts to view their report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1721
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "39fd24f1-2645-4bfd-a428-db8cb8916a7b",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} deletes the report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1894
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "340b0b48-a7ad-4b99-bb65-b59e0ccea5d4",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} accesses the site directly"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2006
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "1a074240-19af-405b-8ddf-d38c13ded132",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see a sample report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2147
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "c35e4693-0179-4f95-82b6-c65f39d5fbda",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see the(ir) test results"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2271
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "67dbbae9-4813-458d-80be-64c69c4ad861",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that the report is scheduled for deletion"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2401
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "832607c4-2e20-4bd6-ab4f-2de60d496fd8",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see the message:"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2561
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "88df1b19-a55b-463f-9b1a-79a0580dc51b",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "no report should be published"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2720
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "95a71aa1-88f7-41f8-91a5-09ba9401056a",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that the report was deleted"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2848
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "799b3146-ad8a-481d-a873-ef693f97f7ae",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that no report was found"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2982
        }
      }
    }
  },
  {
    "source": {
      "uri": "features/tokens.feature",
      "data": "Feature: Tokens\n\n  A previous incarnation of the service supported private long-lived reports with a private token.\n  Since this is no longer available, we reject any attempt to publish a report with a token.\n\n  Scenario: Publishing a report with a private token\n    Given Amanda has a private token\n    When Amanda publishes a report\n    Then Amanda should see the message:\n      \"\"\"\n      ┌──────────────────────────────────────────────────┐\n      │ Private reports are no longer supported.         │\n      │ You can still publish anonymous (public) reports │\n      │ by removing the token from your configuration.   │\n      └──────────────────────────────────────────────────┘\n      \"\"\"\n    And no report should be published",
      "mediaType": "text/x.cucumber.gherkin+plain"
    }
  },
  {
    "gherkinDocument": {
      "uri": "features/tokens.feature",
      "feature": {
        "tags": [],
        "location": {
          "line": 1,
          "column": 1
        },
        "language": "en",
        "keyword": "Feature",
        "name": "Tokens",
        "description": "  A previous incarnation of the service supported private long-lived reports with a private token.\n  Since this is no longer available, we reject any attempt to publish a report with a token.",
        "children": [
          {
            "scenario": {
              "id": "48149a1f-98e1-4225-9b1b-062bc40eb1ab",
              "tags": [],
              "location": {
                "line": 6,
                "column": 3
              },
              "keyword": "Scenario",
              "name": "Publishing a report with a private token",
              "description": "",
              "steps": [
                {
                  "id": "42b6da31-3756-4814-8449-245a3eb25bb7",
                  "location": {
                    "line": 7,
                    "column": 5
                  },
                  "keyword": "Given ",
                  "keywordType": "Context",
                  "text": "Amanda has a private token"
                },
                {
                  "id": "64b19484-a95e-4c58-a603-7102124797e5",
                  "location": {
                    "line": 8,
                    "column": 5
                  },
                  "keyword": "When ",
                  "keywordType": "Action",
                  "text": "Amanda publishes a report"
                },
                {
                  "id": "e9dd9532-5769-46fd-a470-c93b3d9c7d61",
                  "location": {
                    "line": 9,
                    "column": 5
                  },
                  "keyword": "Then ",
                  "keywordType": "Outcome",
                  "text": "Amanda should see the message:",
                  "docString": {
                    "location": {
                      "line": 10,
                      "column": 7
                    },
                    "content": "┌──────────────────────────────────────────────────┐\n│ Private reports are no longer supported.         │\n│ You can still publish anonymous (public) reports │\n│ by removing the token from your configuration.   │\n└──────────────────────────────────────────────────┘",
                    "delimiter": "\"\"\""
                  }
                },
                {
                  "id": "fd8e98bd-c09a-4a1a-b162-22f7ae4865b7",
                  "location": {
                    "line": 17,
                    "column": 5
                  },
                  "keyword": "And ",
                  "keywordType": "Conjunction",
                  "text": "no report should be published"
                }
              ],
              "examples": []
            }
          }
        ]
      },
      "comments": []
    }
  },
  {
    "pickle": {
      "id": "c107bdc1-3b0b-4207-9c69-ed5cda512df9",
      "uri": "features/tokens.feature",
      "astNodeIds": ["48149a1f-98e1-4225-9b1b-062bc40eb1ab"],
      "tags": [],
      "name": "Publishing a report with a private token",
      "language": "en",
      "steps": [
        {
          "id": "c8446c49-286f-47c1-895a-18e1635f77c6",
          "text": "Amanda has a private token",
          "type": "Context",
          "astNodeIds": ["42b6da31-3756-4814-8449-245a3eb25bb7"]
        },
        {
          "id": "7f46a09e-5b5a-4afa-a79f-ed7835d98776",
          "text": "Amanda publishes a report",
          "type": "Action",
          "astNodeIds": ["64b19484-a95e-4c58-a603-7102124797e5"]
        },
        {
          "id": "dfe9bdf5-c70d-4986-baf6-0118e08cdb86",
          "text": "Amanda should see the message:",
          "type": "Outcome",
          "argument": {
            "docString": {
              "content": "┌──────────────────────────────────────────────────┐\n│ Private reports are no longer supported.         │\n│ You can still publish anonymous (public) reports │\n│ by removing the token from your configuration.   │\n└──────────────────────────────────────────────────┘"
            }
          },
          "astNodeIds": ["e9dd9532-5769-46fd-a470-c93b3d9c7d61"]
        },
        {
          "id": "368a9139-a057-49ca-9faf-9130f8a26157",
          "text": "no report should be published",
          "type": "Outcome",
          "astNodeIds": ["fd8e98bd-c09a-4a1a-b162-22f7ae4865b7"]
        }
      ]
    }
  },
  {
    "parameterType": {
      "id": "8cd104ab-d85f-483e-a0a0-f2110e7eaa83",
      "name": "actor",
      "regularExpressions": ["[A-Z][a-z]+"],
      "preferForRegularExpressionMatch": false,
      "useForSnippets": true,
      "sourceReference": {
        "uri": "features/steps/setup.mts",
        "location": {
          "line": 1,
          "column": 201
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "c1ddd0b2-e84a-436b-b4c1-caa436f58273",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} has a private token"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 621
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "46e77e71-54c5-4214-abd0-09cc940d4270",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "a report previously published by {actor} has been deleted"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 746
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "04a18a55-0dee-4525-b9f9-89049585e1da",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} publishes a report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 963
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "bb3a8bca-dd60-4a8e-9f7a-d809f2a1724c",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} shares their link with {actor}"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1193
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "de12e3f1-2fc8-4375-8fba-8324303f2ae0",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} views the report they just published"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1378
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "66c90179-b85b-4786-8b12-bc5d06b7ab84",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} views the shared report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1558
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "62d14832-1bf4-4c21-8ec1-f7272c32e15b",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} attempts to view their report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1721
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "392988ab-a9a9-4573-89c4-66df5eb15091",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} deletes the report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1894
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "c743ba82-5f44-4c62-a16a-e41351cf9816",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} accesses the site directly"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2006
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "c9ed67cb-5fc8-4835-b0ff-ef98698feaca",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see a sample report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2147
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "eb3e81fd-82ba-4b3d-9cbf-42475a512ca7",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see the(ir) test results"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2271
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "89be2d33-74e1-45ef-b1cf-dd6087ccd873",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that the report is scheduled for deletion"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2401
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "337518cf-15de-48ac-805a-584e8c23950f",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see the message:"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2561
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "c379de00-3d42-4bd1-95ef-281c528c63e9",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "no report should be published"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2720
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "b3f0d0c8-5b12-483e-b8ab-587aa23a0580",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that the report was deleted"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2848
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "f9810b29-da4c-4eb0-b874-f24024e08148",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that no report was found"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2982
        }
      }
    }
  },
  {
    "source": {
      "uri": "features/welcome.feature",
      "data": "Feature: Welcome\n\n  Scenario: Sample report\n    When Frank accesses the site directly\n    Then Frank should see a sample report",
      "mediaType": "text/x.cucumber.gherkin+plain"
    }
  },
  {
    "gherkinDocument": {
      "uri": "features/welcome.feature",
      "feature": {
        "tags": [],
        "location": {
          "line": 1,
          "column": 1
        },
        "language": "en",
        "keyword": "Feature",
        "name": "Welcome",
        "description": "",
        "children": [
          {
            "scenario": {
              "id": "ec9a687f-092a-405d-91f5-13d323042382",
              "tags": [],
              "location": {
                "line": 3,
                "column": 3
              },
              "keyword": "Scenario",
              "name": "Sample report",
              "description": "",
              "steps": [
                {
                  "id": "d14d5506-3949-4af3-a756-7700e26b876c",
                  "location": {
                    "line": 4,
                    "column": 5
                  },
                  "keyword": "When ",
                  "keywordType": "Action",
                  "text": "Frank accesses the site directly"
                },
                {
                  "id": "25badacf-6654-4437-b4b3-0c968f3d3a9d",
                  "location": {
                    "line": 5,
                    "column": 5
                  },
                  "keyword": "Then ",
                  "keywordType": "Outcome",
                  "text": "Frank should see a sample report"
                }
              ],
              "examples": []
            }
          }
        ]
      },
      "comments": []
    }
  },
  {
    "pickle": {
      "id": "f775f498-b554-4b3d-b1f1-5720e34c07af",
      "uri": "features/welcome.feature",
      "astNodeIds": ["ec9a687f-092a-405d-91f5-13d323042382"],
      "tags": [],
      "name": "Sample report",
      "language": "en",
      "steps": [
        {
          "id": "f2bc82c0-b67a-4033-b7c8-83cb560a578e",
          "text": "Frank accesses the site directly",
          "type": "Action",
          "astNodeIds": ["d14d5506-3949-4af3-a756-7700e26b876c"]
        },
        {
          "id": "f43506a1-111f-4ca4-b443-12c5733ac2a4",
          "text": "Frank should see a sample report",
          "type": "Outcome",
          "astNodeIds": ["25badacf-6654-4437-b4b3-0c968f3d3a9d"]
        }
      ]
    }
  },
  {
    "parameterType": {
      "id": "2244f6bd-c989-4c40-9b56-bd6353d220c0",
      "name": "actor",
      "regularExpressions": ["[A-Z][a-z]+"],
      "preferForRegularExpressionMatch": false,
      "useForSnippets": true,
      "sourceReference": {
        "uri": "features/steps/setup.mts",
        "location": {
          "line": 1,
          "column": 201
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "03170ca4-32b8-484d-a0ed-ede5012a02da",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} has a private token"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 621
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "3da5ff94-795d-42d5-84f9-8de7e76a5a07",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "a report previously published by {actor} has been deleted"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 746
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "f95414eb-34c5-4982-aa50-1c7c3ddcc73c",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} publishes a report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 963
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "90f624cd-18d3-4285-ba40-b45aad915351",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} shares their link with {actor}"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1193
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "e87e852e-10db-44eb-a0d2-c650e8c15d46",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} views the report they just published"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1378
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "ac1d7173-187e-4e09-92bb-ed6296ba8f1d",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} views the shared report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1558
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "3cf76844-cce3-4a19-a95b-80363d3e9e9c",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} attempts to view their report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1721
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "f017deed-65be-4858-b2d8-55b97ba0335c",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} deletes the report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 1894
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "b2969b83-c2f2-44ab-bf5c-f4be6a04cbc7",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} accesses the site directly"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2006
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "fa8d7340-24d5-4081-9319-327f5ce6c2cd",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see a sample report"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2147
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "f361cf3f-a971-4e53-907f-262385a6de37",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see the(ir) test results"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2271
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "1011107d-9b2a-42b0-bd4e-f0c1c9e2d623",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that the report is scheduled for deletion"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2401
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "a01b9769-74f2-425d-ba42-87e5928b2522",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see the message:"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2561
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "f1b315ab-b641-414a-8bff-39c7d45df381",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "no report should be published"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2720
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "cfa42233-03c9-4ef9-b8d7-95d549072b19",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that the report was deleted"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2848
        }
      }
    }
  },
  {
    "stepDefinition": {
      "id": "246d7423-ae2a-4fa0-989c-7fc2a64186be",
      "pattern": {
        "type": "CUCUMBER_EXPRESSION",
        "source": "{actor} should see that no report was found"
      },
      "sourceReference": {
        "uri": "features/steps/steps.mts",
        "location": {
          "line": 1,
          "column": 2982
        }
      }
    }
  },
  {
    "testRunStarted": {
      "id": "535cdb12-c0ac-40d8-a270-059b9fc9263e",
      "timestamp": {
        "seconds": 1748758917,
        "nanos": 163000000
      }
    }
  },
  {
    "testCase": {
      "id": "85a4f2d1-dc19-49f9-ad49-8a0c4862363e",
      "pickleId": "167acb8f-e467-4fa6-b9f3-0a9192f0ee3a",
      "testSteps": [
        {
          "id": "7a4c4f00-a459-415d-a47d-0e746a54cb71",
          "pickleStepId": "b3863557-92ca-431b-8f2b-d411e5d5c555",
          "stepDefinitionIds": ["82b2a494-d7f9-4a2a-a525-fe07cbb4ed89"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Bruno",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "7de8ae4c-2601-4b26-8bcc-41636fd7d9f8",
          "pickleStepId": "231fc513-2272-40f9-9d58-c2e54666660f",
          "stepDefinitionIds": ["9b0eb230-4b77-4ee3-8bea-8ee4569bf8ca"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Bruno",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "c4e05cc4-9bb2-4c9f-bea9-a9a5d4f598da",
          "pickleStepId": "41111b06-28dd-4c76-92df-49d7d634735e",
          "stepDefinitionIds": ["aa48b142-fc4b-4058-ac20-d65bd1770df1"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Bruno",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        }
      ],
      "testRunStartedId": "535cdb12-c0ac-40d8-a270-059b9fc9263e"
    }
  },
  {
    "testCase": {
      "id": "feb1a117-5bd4-4ddd-9bab-e66e99b52736",
      "pickleId": "aea12470-363c-4258-83c2-6fe76654fb47",
      "testSteps": [
        {
          "id": "ec4d15ae-03de-4e1f-af16-b609e3931a55",
          "pickleStepId": "1bb2b0e3-f043-4466-a0d9-ff0705354280",
          "stepDefinitionIds": ["82b2a494-d7f9-4a2a-a525-fe07cbb4ed89"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Clara",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "840b0310-4adf-4a03-a0fb-7b1f23656f59",
          "pickleStepId": "60e8eef7-b90a-44e9-b909-fe1387030ea1",
          "stepDefinitionIds": ["9b0eb230-4b77-4ee3-8bea-8ee4569bf8ca"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Clara",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "659df307-5581-41aa-9580-f4ba6b396be1",
          "pickleStepId": "f8f38cf2-c675-4196-9a43-e2375d05f0c4",
          "stepDefinitionIds": ["7d178177-12b8-450b-84fa-90d0ce98a463"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Clara",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "377c0113-7d3b-419e-8694-07cf402913e2",
          "pickleStepId": "18f03b3b-5fa9-4cb1-b068-4465136ada62",
          "stepDefinitionIds": ["1ef6165e-3f71-4087-940d-e51aaec16a00"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Clara",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        }
      ],
      "testRunStartedId": "535cdb12-c0ac-40d8-a270-059b9fc9263e"
    }
  },
  {
    "testCase": {
      "id": "5a1bb83c-c59a-41d3-8732-a63cba6922ed",
      "pickleId": "c1c81fc5-a115-4e53-b431-173ab1f27d12",
      "testSteps": [
        {
          "id": "5d1b8c2f-8d1d-4606-adc9-dbecb9572d80",
          "pickleStepId": "4627173e-f187-4020-b26c-b620643b7e69",
          "stepDefinitionIds": ["faa5218b-a490-4e70-85ef-01dd8a45d8be"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 33,
                    "value": "Esme",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "13000bda-ed74-443c-9174-c7e9008ac64a",
          "pickleStepId": "9396b6c7-3bff-4679-ab54-11492479934d",
          "stepDefinitionIds": ["c9258031-5b07-4570-9273-0db9e403ab3e"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Esme",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "0f70bb14-2ba4-4132-9cb8-ba73714cc717",
          "pickleStepId": "ae829390-91e2-4f1c-a0f2-74a195e0ca3f",
          "stepDefinitionIds": ["28f258b9-f2f9-4cab-a1ed-3d09c465d784"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Esme",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        }
      ],
      "testRunStartedId": "535cdb12-c0ac-40d8-a270-059b9fc9263e"
    }
  },
  {
    "testCaseStarted": {
      "id": "56205a2b-5faa-4581-8f55-10556a5f3de1",
      "testCaseId": "85a4f2d1-dc19-49f9-ad49-8a0c4862363e",
      "attempt": 0,
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 492000000
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "56205a2b-5faa-4581-8f55-10556a5f3de1",
      "testStepId": "7a4c4f00-a459-415d-a47d-0e746a54cb71",
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 492000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "56205a2b-5faa-4581-8f55-10556a5f3de1",
      "testStepId": "7a4c4f00-a459-415d-a47d-0e746a54cb71",
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 961000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 1,
          "nanos": 467949125
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "56205a2b-5faa-4581-8f55-10556a5f3de1",
      "testStepId": "7de8ae4c-2601-4b26-8bcc-41636fd7d9f8",
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 961000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "56205a2b-5faa-4581-8f55-10556a5f3de1",
      "testStepId": "7de8ae4c-2601-4b26-8bcc-41636fd7d9f8",
      "timestamp": {
        "seconds": 1748758921,
        "nanos": 876000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 1,
          "nanos": 914603333
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "56205a2b-5faa-4581-8f55-10556a5f3de1",
      "testStepId": "c4e05cc4-9bb2-4c9f-bea9-a9a5d4f598da",
      "timestamp": {
        "seconds": 1748758921,
        "nanos": 876000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "56205a2b-5faa-4581-8f55-10556a5f3de1",
      "testStepId": "c4e05cc4-9bb2-4c9f-bea9-a9a5d4f598da",
      "timestamp": {
        "seconds": 1748758921,
        "nanos": 983000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 106490625
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testCaseFinished": {
      "testCaseStartedId": "56205a2b-5faa-4581-8f55-10556a5f3de1",
      "willBeRetried": false,
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 103000000
      }
    }
  },
  {
    "testCaseStarted": {
      "id": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "testCaseId": "feb1a117-5bd4-4ddd-9bab-e66e99b52736",
      "attempt": 0,
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 104000000
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "testStepId": "ec4d15ae-03de-4e1f-af16-b609e3931a55",
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 104000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "testStepId": "ec4d15ae-03de-4e1f-af16-b609e3931a55",
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 195000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 90839125
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "testStepId": "840b0310-4adf-4a03-a0fb-7b1f23656f59",
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 195000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "testStepId": "840b0310-4adf-4a03-a0fb-7b1f23656f59",
      "timestamp": {
        "seconds": 1748758923,
        "nanos": 407000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 1,
          "nanos": 211665625
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "testStepId": "659df307-5581-41aa-9580-f4ba6b396be1",
      "timestamp": {
        "seconds": 1748758923,
        "nanos": 407000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "testStepId": "659df307-5581-41aa-9580-f4ba6b396be1",
      "timestamp": {
        "seconds": 1748758923,
        "nanos": 564000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 156379750
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "testStepId": "377c0113-7d3b-419e-8694-07cf402913e2",
      "timestamp": {
        "seconds": 1748758923,
        "nanos": 564000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "testStepId": "377c0113-7d3b-419e-8694-07cf402913e2",
      "timestamp": {
        "seconds": 1748758923,
        "nanos": 851000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 287465750
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testCaseFinished": {
      "testCaseStartedId": "bbae188c-2c60-4aa9-b9de-2f7502c5f903",
      "willBeRetried": false,
      "timestamp": {
        "seconds": 1748758924,
        "nanos": 239000000
      }
    }
  },
  {
    "testCaseStarted": {
      "id": "86065051-c060-4f33-8333-e31da7a439cd",
      "testCaseId": "5a1bb83c-c59a-41d3-8732-a63cba6922ed",
      "attempt": 0,
      "timestamp": {
        "seconds": 1748758924,
        "nanos": 240000000
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "86065051-c060-4f33-8333-e31da7a439cd",
      "testStepId": "5d1b8c2f-8d1d-4606-adc9-dbecb9572d80",
      "timestamp": {
        "seconds": 1748758924,
        "nanos": 240000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "86065051-c060-4f33-8333-e31da7a439cd",
      "testStepId": "5d1b8c2f-8d1d-4606-adc9-dbecb9572d80",
      "timestamp": {
        "seconds": 1748758924,
        "nanos": 240000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 162542
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "86065051-c060-4f33-8333-e31da7a439cd",
      "testStepId": "13000bda-ed74-443c-9174-c7e9008ac64a",
      "timestamp": {
        "seconds": 1748758924,
        "nanos": 240000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "86065051-c060-4f33-8333-e31da7a439cd",
      "testStepId": "13000bda-ed74-443c-9174-c7e9008ac64a",
      "timestamp": {
        "seconds": 1748758925,
        "nanos": 15000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 775086458
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "86065051-c060-4f33-8333-e31da7a439cd",
      "testStepId": "0f70bb14-2ba4-4132-9cb8-ba73714cc717",
      "timestamp": {
        "seconds": 1748758925,
        "nanos": 15000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "86065051-c060-4f33-8333-e31da7a439cd",
      "testStepId": "0f70bb14-2ba4-4132-9cb8-ba73714cc717",
      "timestamp": {
        "seconds": 1748758925,
        "nanos": 57000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 41278375
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testCaseFinished": {
      "testCaseStartedId": "86065051-c060-4f33-8333-e31da7a439cd",
      "willBeRetried": false,
      "timestamp": {
        "seconds": 1748758925,
        "nanos": 142000000
      }
    }
  },
  {
    "testCase": {
      "id": "5b2f0960-802a-4a75-906f-0fb15facccc6",
      "pickleId": "cb587150-8686-4ef8-a299-d2963a20429c",
      "testSteps": [
        {
          "id": "cab330b4-eb29-4ac7-965f-a9dfeff5d020",
          "pickleStepId": "3a7cfbbe-5ec0-4218-9179-a5216014a701",
          "stepDefinitionIds": ["54ce4487-50ba-4382-9903-9f2ff2f19cb7"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "David",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "e9f8ee3c-3eb7-480b-bb8e-57f9550977c6",
          "pickleStepId": "fde4bbce-f08d-4faf-869a-4d3ffd92570f",
          "stepDefinitionIds": ["eb99bfd3-f2a0-4351-8503-57772bd4eb46"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "David",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "2f51f5c8-8dc2-484a-b5f9-de309762da68",
          "pickleStepId": "06622832-9d95-4f58-8347-eb2f6126a461",
          "stepDefinitionIds": ["c35e4693-0179-4f95-82b6-c65f39d5fbda"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "David",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        }
      ],
      "testRunStartedId": "535cdb12-c0ac-40d8-a270-059b9fc9263e"
    }
  },
  {
    "testCase": {
      "id": "6a78b860-eeb4-4172-822c-b53d5d1fb7ce",
      "pickleId": "24bee1a1-8d28-4771-a3eb-d20a4c2cf26c",
      "testSteps": [
        {
          "id": "02fab9a1-9145-448b-a0bb-027bd7d2ad96",
          "pickleStepId": "dac60d43-b9aa-4ac4-9c79-ba75cc2a9019",
          "stepDefinitionIds": ["54ce4487-50ba-4382-9903-9f2ff2f19cb7"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Garrett",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "2311d9aa-81b8-4100-a3dc-50934ccfa2c6",
          "pickleStepId": "2063c9d5-706f-4818-a4a5-e654a23662ee",
          "stepDefinitionIds": ["839b104f-abce-44d4-bbc3-30af6a1d953f"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Garrett",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                },
                {
                  "group": {
                    "start": 31,
                    "value": "Hannah",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "dd917bc1-1e82-4e71-91ca-e63c622029ee",
          "pickleStepId": "624d8291-6722-42e7-8327-d163476b9bc5",
          "stepDefinitionIds": ["8982004d-ce05-46a5-b7f4-4481ec99f750"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Hannah",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "87e0f806-725c-48df-a328-413919d625cf",
          "pickleStepId": "0013d8df-acfd-457c-9aff-8241bda6fdf0",
          "stepDefinitionIds": ["c35e4693-0179-4f95-82b6-c65f39d5fbda"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Hannah",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        }
      ],
      "testRunStartedId": "535cdb12-c0ac-40d8-a270-059b9fc9263e"
    }
  },
  {
    "testCaseStarted": {
      "id": "9e4febe6-03c1-4c95-aa79-a92c04f3499c",
      "testCaseId": "5b2f0960-802a-4a75-906f-0fb15facccc6",
      "attempt": 0,
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 490000000
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "9e4febe6-03c1-4c95-aa79-a92c04f3499c",
      "testStepId": "cab330b4-eb29-4ac7-965f-a9dfeff5d020",
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 490000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "9e4febe6-03c1-4c95-aa79-a92c04f3499c",
      "testStepId": "cab330b4-eb29-4ac7-965f-a9dfeff5d020",
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 961000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 1,
          "nanos": 469769041
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "9e4febe6-03c1-4c95-aa79-a92c04f3499c",
      "testStepId": "e9f8ee3c-3eb7-480b-bb8e-57f9550977c6",
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 961000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "9e4febe6-03c1-4c95-aa79-a92c04f3499c",
      "testStepId": "e9f8ee3c-3eb7-480b-bb8e-57f9550977c6",
      "timestamp": {
        "seconds": 1748758921,
        "nanos": 863000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 1,
          "nanos": 902409542
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "9e4febe6-03c1-4c95-aa79-a92c04f3499c",
      "testStepId": "2f51f5c8-8dc2-484a-b5f9-de309762da68",
      "timestamp": {
        "seconds": 1748758921,
        "nanos": 864000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "9e4febe6-03c1-4c95-aa79-a92c04f3499c",
      "testStepId": "2f51f5c8-8dc2-484a-b5f9-de309762da68",
      "timestamp": {
        "seconds": 1748758921,
        "nanos": 980000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 115816000
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testCaseFinished": {
      "testCaseStartedId": "9e4febe6-03c1-4c95-aa79-a92c04f3499c",
      "willBeRetried": false,
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 105000000
      }
    }
  },
  {
    "testCaseStarted": {
      "id": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "testCaseId": "6a78b860-eeb4-4172-822c-b53d5d1fb7ce",
      "attempt": 0,
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 105000000
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "testStepId": "02fab9a1-9145-448b-a0bb-027bd7d2ad96",
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 106000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "testStepId": "02fab9a1-9145-448b-a0bb-027bd7d2ad96",
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 193000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 87301250
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "testStepId": "2311d9aa-81b8-4100-a3dc-50934ccfa2c6",
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 193000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "testStepId": "2311d9aa-81b8-4100-a3dc-50934ccfa2c6",
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 193000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 190084
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "testStepId": "dd917bc1-1e82-4e71-91ca-e63c622029ee",
      "timestamp": {
        "seconds": 1748758922,
        "nanos": 193000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "testStepId": "dd917bc1-1e82-4e71-91ca-e63c622029ee",
      "timestamp": {
        "seconds": 1748758923,
        "nanos": 388000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 1,
          "nanos": 193063374
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "testStepId": "87e0f806-725c-48df-a328-413919d625cf",
      "timestamp": {
        "seconds": 1748758923,
        "nanos": 388000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "testStepId": "87e0f806-725c-48df-a328-413919d625cf",
      "timestamp": {
        "seconds": 1748758923,
        "nanos": 534000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 145108792
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testCaseFinished": {
      "testCaseStartedId": "f19f0f22-7000-426b-838d-f6317d0d842a",
      "willBeRetried": false,
      "timestamp": {
        "seconds": 1748758924,
        "nanos": 239000000
      }
    }
  },
  {
    "testCase": {
      "id": "f9d3d4cc-d857-444d-867a-d1a709c86dd3",
      "pickleId": "c107bdc1-3b0b-4207-9c69-ed5cda512df9",
      "testSteps": [
        {
          "id": "1f0d2309-bdd7-4797-a8e7-cd7454888254",
          "pickleStepId": "c8446c49-286f-47c1-895a-18e1635f77c6",
          "stepDefinitionIds": ["c1ddd0b2-e84a-436b-b4c1-caa436f58273"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Amanda",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "1d93c66c-292c-4398-9b48-3c05478762a5",
          "pickleStepId": "7f46a09e-5b5a-4afa-a79f-ed7835d98776",
          "stepDefinitionIds": ["04a18a55-0dee-4525-b9f9-89049585e1da"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Amanda",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "61b85813-4898-413c-9b2d-3e5fa6d3b694",
          "pickleStepId": "dfe9bdf5-c70d-4986-baf6-0118e08cdb86",
          "stepDefinitionIds": ["337518cf-15de-48ac-805a-584e8c23950f"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Amanda",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "2b25b354-7bbb-4ed8-800a-6c4a8d9cd0a9",
          "pickleStepId": "368a9139-a057-49ca-9faf-9130f8a26157",
          "stepDefinitionIds": ["c379de00-3d42-4bd1-95ef-281c528c63e9"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": []
            }
          ]
        }
      ],
      "testRunStartedId": "535cdb12-c0ac-40d8-a270-059b9fc9263e"
    }
  },
  {
    "testCaseStarted": {
      "id": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "testCaseId": "f9d3d4cc-d857-444d-867a-d1a709c86dd3",
      "attempt": 0,
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 489000000
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "testStepId": "1f0d2309-bdd7-4797-a8e7-cd7454888254",
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 489000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "testStepId": "1f0d2309-bdd7-4797-a8e7-cd7454888254",
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 492000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 687000
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "testStepId": "1d93c66c-292c-4398-9b48-3c05478762a5",
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 492000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "testStepId": "1d93c66c-292c-4398-9b48-3c05478762a5",
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 925000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 1,
          "nanos": 433162207
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "testStepId": "61b85813-4898-413c-9b2d-3e5fa6d3b694",
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 925000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "testStepId": "61b85813-4898-413c-9b2d-3e5fa6d3b694",
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 926000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 244292
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "testStepId": "2b25b354-7bbb-4ed8-800a-6c4a8d9cd0a9",
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 926000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "testStepId": "2b25b354-7bbb-4ed8-800a-6c4a8d9cd0a9",
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 926000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 342417
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testCaseFinished": {
      "testCaseStartedId": "ae8e89a5-1406-45c8-8891-4f7d5c1ba349",
      "willBeRetried": false,
      "timestamp": {
        "seconds": 1748758919,
        "nanos": 926000000
      }
    }
  },
  {
    "testCase": {
      "id": "0a6ef48b-cf7f-4522-bcbd-e69da9b89299",
      "pickleId": "f775f498-b554-4b3d-b1f1-5720e34c07af",
      "testSteps": [
        {
          "id": "d14ba90c-5e0a-4eef-b1e3-b6734a026dff",
          "pickleStepId": "f2bc82c0-b67a-4033-b7c8-83cb560a578e",
          "stepDefinitionIds": ["b2969b83-c2f2-44ab-bf5c-f4be6a04cbc7"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Frank",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        },
        {
          "id": "1e36a4ba-0d70-4ce0-aca0-931e83136228",
          "pickleStepId": "f43506a1-111f-4ca4-b443-12c5733ac2a4",
          "stepDefinitionIds": ["fa8d7340-24d5-4081-9319-327f5ce6c2cd"],
          "stepMatchArgumentsLists": [
            {
              "stepMatchArguments": [
                {
                  "group": {
                    "start": 0,
                    "value": "Frank",
                    "children": []
                  },
                  "parameterTypeName": "actor"
                }
              ]
            }
          ]
        }
      ],
      "testRunStartedId": "535cdb12-c0ac-40d8-a270-059b9fc9263e"
    }
  },
  {
    "testCaseStarted": {
      "id": "a4f723f4-0c4d-4c4f-ae93-be9f9d8f0f18",
      "testCaseId": "0a6ef48b-cf7f-4522-bcbd-e69da9b89299",
      "attempt": 0,
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 486000000
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "a4f723f4-0c4d-4c4f-ae93-be9f9d8f0f18",
      "testStepId": "d14ba90c-5e0a-4eef-b1e3-b6734a026dff",
      "timestamp": {
        "seconds": 1748758918,
        "nanos": 486000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "a4f723f4-0c4d-4c4f-ae93-be9f9d8f0f18",
      "testStepId": "d14ba90c-5e0a-4eef-b1e3-b6734a026dff",
      "timestamp": {
        "seconds": 1748758920,
        "nanos": 996000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 2,
          "nanos": 508649374
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testStepStarted": {
      "testCaseStartedId": "a4f723f4-0c4d-4c4f-ae93-be9f9d8f0f18",
      "testStepId": "1e36a4ba-0d70-4ce0-aca0-931e83136228",
      "timestamp": {
        "seconds": 1748758920,
        "nanos": 996000000
      }
    }
  },
  {
    "testStepFinished": {
      "testCaseStartedId": "a4f723f4-0c4d-4c4f-ae93-be9f9d8f0f18",
      "testStepId": "1e36a4ba-0d70-4ce0-aca0-931e83136228",
      "timestamp": {
        "seconds": 1748758921,
        "nanos": 105000000
      },
      "testStepResult": {
        "duration": {
          "seconds": 0,
          "nanos": 108411333
        },
        "status": "PASSED"
      }
    }
  },
  {
    "testCaseFinished": {
      "testCaseStartedId": "a4f723f4-0c4d-4c4f-ae93-be9f9d8f0f18",
      "willBeRetried": false,
      "timestamp": {
        "seconds": 1748758921,
        "nanos": 450000000
      }
    }
  },
  {
    "testRunFinished": {
      "testRunStartedId": "535cdb12-c0ac-40d8-a270-059b9fc9263e",
      "timestamp": {
        "seconds": 1748758925,
        "nanos": 195000000
      },
      "success": true
    }
  }
]
